import ProviderManage from "./manage"

export default ProviderManage
